/*
 * @Author: yuxh yuxh_157@163.com
 * @Date: 2024-06-18 10:58:46
 * @LastEditors: yuxh yuxh_157@163.com
 * @LastEditTime: 2024-06-18 11:12:36
 * @FilePath: /akx-factory-main/src/login/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login.vue";
import Register from "../views/register.vue";
import Pass from "../views/pass.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/pass",
    name: "Pass",
    component: Pass,
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
